import useTranslate from '@root/core/hooks/useTranslate';
import { ProductContext } from '@root/modules/Sellers/provider/ProductProvider';
import BreadcrumbList from '@root/modules/Sellers/Stock/components/Breadcrumb';
import { Card } from 'antd';
import { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import TableInventory from '../components/TableInventory';
const breadcrumbList = [
  {
    tittle: 'Inventory',
    url: '/admin/inventory'
  },
  {
    tittle: 'Seller List',
    url: ''
  }
];

const InventoryHome = () => {
  const [t] = useTranslate();

  return (
    <>
      <BreadcrumbList listBreadcrumb={breadcrumbList} />

      <div className="admin-container ">
        <Card
          bordered={false}
          className="admin-card"
          style={{
            minHeight: '80vh',
            background: 'none'
          }}
        >
          <TableInventory />
        </Card>
      </div>
    </>
  );
};

export default InventoryHome;
